import $ from 'jquery'

class Landing {
  mode;
  items;
  navLinks;
  itemsContainer;
  navContainer;
  itemTransition;
  index=0;
  position=0;
  constructor(mode, itemsContainer, navContainer) {
    this.mode=mode;
    this.itemsContainer=itemsContainer;
    this.navContainer=navContainer;
    this.items=itemsContainer.find(">*");
    this.navLinks=navContainer.find(">*");

    if (this.mode=="fade")
      this.itemTransition=new LandingFade(this.itemContainer, this.items);

    var that=this;
    this.navLinks.click(function (e) {
      e.preventDefault();
      var newIndex=that.navLinks.index(this);
      that.moveTo(newIndex);
    });
    this.moveTo(0);
    this.addTouchHover();
  }
  moveTo(index) {
    this.index=index;
    this.position=0;
    this.updateLinks();
    this.updateItems();
  }
  updateItems() {
    if (this.itemTransition) {
      this.itemTransition.index=this.index;
      this.itemTransition.position=this.position;
      this.itemTransition.updateItems();
    } else {
      this.navLinks.removeClass("active").eq(this.index).addClass("active");
    }
  }
  updateLinks() {
    this.items.removeClass("active").eq(this.index).addClass("active");
  }
  addTouchHover() {
    var that=this;
    this.items.on("touchstart", function() {
      var index=that.items.index(this);
      that.items.removeClass("hover").eq(index).addClass("hover");
    });
  }
}

class LandingFade {
  itemContainer;
  items;
  index=0;
  position=0;
  lru=[];
  constructor(itemContainer, items) {
    this.itemContainer=itemContainer;
    this.items=items;
  }
  updateItems() {
    if (this.lru.indexOf(this.index*1)!=-1)
      this.lru.splice(this.lru.indexOf(this.index*1), 1);
    this.lru.push(this.index*1);
    for(var i=0;i<this.items.length;i++) {
      this.items.eq(i).css({"z-index": this.lru.indexOf(i)});
    }
    this.items.css({"transition": "none"}).eq(this.index).css({"opacity": "0"});
    setTimeout(()=>{
      this.items.eq(this.index).css({"opacity": 1, "transition": "opacity .3s"});
    }, 16);
  }
}


$("[data-landing]").each(function() {
  new Landing($(this).attr("data-landing"),
               $(this).find("[data-landing-role=items]"),
               $(this).find("[data-landing-role=nav]"));
});
